const secondaryNavTabsEnum = Object.freeze({
  INFO: 'Info',
  MARKERS: 'Markers',
  NOTES: 'Notes',
  BATCHEDIT: 'Batch',
});

export default secondaryNavTabsEnum;
